import { Badge } from "@/components/ui/badge";
import { useLanguage } from "@/contexts/LanguageContext";
import { CheckCircle2, Clock, Mail } from "lucide-react";
import { CompanyAccountState } from "@/types/company/company.types";

interface AccountStatusBadgeProps {
  accountState: CompanyAccountState;
}

export const AccountStatusBadge = ({ accountState }: AccountStatusBadgeProps) => {
  const { t } = useLanguage();

  if (accountState.isRegistered) {
    return (
      <Badge variant="success" className="flex items-center gap-1.5">
        <CheckCircle2 className="h-3.5 w-3.5" />
        {t("companyForm.account.registered")}
      </Badge>
    );
  }

  if (accountState.hasAssociatedAccount) {
    return (
      <Badge variant="warning" className="flex items-center gap-1.5">
        <Clock className="h-3.5 w-3.5" />
        {t("companyForm.account.pendingRegistration")}
      </Badge>
    );
  }

  return (
    <Badge variant="secondary" className="flex items-center gap-1.5">
      <Mail className="h-3.5 w-3.5" />
      {t("companyForm.account.noAccount")}
    </Badge>
  );
};
